// 検索画面で使用するJS

// 並び替えボタンの文字列セット
(function () {
  const url = new URL(window.location.href);
  const params = url.searchParams;
  const sortByParam = params.get('sort_by');

  const sortModalLabels = document.querySelectorAll('.-sortmodal-label');

  const labelText = (function () {
    switch (sortByParam) {
      case 'created-descending':
        return '新着順';
      case 'price-ascending':
        return '価格が安い順';
      case 'price-descending':
        return '価格が高い順';
      case 'best-selling':
        return '人気順';
      default:
        return '並び替え';
    }
  })();
  sortModalLabels.forEach((label) => {
    label.textContent = labelText;
  });
})();

// 検索の本体
document.addEventListener('DOMContentLoaded', function () {
  const searchClient = algoliasearch('XGVCVXZA9R', 'd009fe9f3b4e6fbf728f3d2c27eda693');//4eb484cde89b687502a1e92d53ae9f16

  const indexName = (function () {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const sortByParam = params.get('sort_by');
    switch (sortByParam) {
      case 'created-descending':
        return 'shopify_products_created_at_desc';
      case 'price-ascending':
        return 'products_price_asc';
      case 'price-descending':
        return 'products_price_desc';
      case 'best-selling':
        return 'shopify_products_recently_ordered_count_desc';
      default:
        return 'shopify_products_created_at_desc';
    }
  })();
  const search = instantsearch({
    indexName: indexName,
    searchClient,
  });

  const url = new URL(window.location.href);
  const pathName  = url.pathname;
  const params = url.searchParams;

  const priceFilter = [];
  const categoryFacetFilters = {};

  let searchTitle = '';

  switch (pathName) {
    case '/collections/red-wine':
      console.log("searchTitle");
      params.set('type', 'red-wine');
      searchTitle = getSearchValue('type', 'red-wine', true);
      break;
    case '/collections/white-wine':
      params.set('type', 'white-wine');
      searchTitle = getSearchValue('type', 'white-wine', true);
      break;
    case '/collections/rose-wine':
      params.set('type', 'rose-wine');
      searchTitle = getSearchValue('type', 'rose-wine', true);
      break;
    case '/collections/orange-wine':
      params.set('type', 'orange-wine');
      searchTitle = getSearchValue('type', 'orange-wine', true);
      break;
    case '/collections/sparkling-wine':
      params.set('type', 'sparkling-wine');
      searchTitle = getSearchValue('type', 'sparkling-wine', true);
      break;
    case '/collections/%E7%89%B9%E9%81%B8%E3%83%AF%E3%82%A4%E3%83%B3':  // ← 追加
    params.set('collections', '特選ワイン');
    searchTitle = getSearchValue('collections', '特選ワイン', true);
    break;
    case '/collections/dealcoholized-wine-juice':
      params.set('type', 'dealcoholized-wine-juice');
      searchTitle = getSearchValue('type', 'dealcoholized-wine-juice', true);
      break;
    case '/collections/beer':
      params.set('type', 'beer');
      searchTitle = getSearchValue('type', 'beer', true);
      break;
    case '/collections/0-999':
      params.set('price', '0-999');
      searchTitle = getSearchValue('price', '0-999', true);
      break;
    case '/collections/1000-1999':
      params.set('price', '1000-1999');
      searchTitle = getSearchValue('price', '1000-1999', true);
      break;
    case '/collections/2000-2999':
      params.set('price', '2000-2999');
      searchTitle = getSearchValue('price', '2000-2999', true);
      break;
    case '/collections/3000-4999':
      params.set('price', '3000-4999');
      searchTitle = getSearchValue('price', '3000-4999', true);
      break;
    case '/collections/5000-9999':
      params.set('price', '5000-9999');
      searchTitle = getSearchValue('price', '5000-9999', true);
      break;
    case '/collections/over10000':
      params.set('price', 'over10000');
      searchTitle = getSearchValue('price', 'over10000', true);
      break;
    case '/collections/gifts':
      params.set('collections', 'gifts');
      searchTitle = getSearchValue('collections', 'gifts', true);
      break;    
    case '/collections/new-arrival':
      params.set('collections', 'New-Arrival');
      searchTitle = getSearchValue('collections', 'New-Arrival', true);
      break;
    case '/collections/spainwinewes':
      params.set('collections', 'spainwinewes');
      searchTitle = getSearchValue('collections', 'spainwinewes', true);
      break;
    case '/collections/clearance202509':
      params.set('collections', 'クリアランスセールベルビーニョ');
      searchTitle = getSearchValue('collections', 'クリアランスセールベルビーニョ', true);
      break;
    case '/collections/daily-use':
      params.set('collections', 'daily-use');
      searchTitle = getSearchValue('collections', 'daily-use', true);
      break;
    case '/collections/spain-wine':
      params.set('country', 'spain');
      searchTitle = getSearchValue('country', 'spain', true);
      break;
        case '/collections/sherry-wine':
      params.set('type', 'sherry-wine');
      searchTitle = 'シェリー酒';
      break;
    case '/collections/pagos-altos-de-acered-wine':
      params.set('collections', 'pagos-altos-de-acered-wine');
      searchTitle = getSearchValue('collections', 'pagos-altos-de-acered-wine', true);
      break;
    default:
      break;
  }

  params.forEach((value, key) => {
    const searchValue = getSearchValue(key, value);
    if (searchValue === '不明な値') return;

    if (!categoryFacetFilters[key]) {
      categoryFacetFilters[key] = [];
    }

    switch (key) {
      case 'type':
        categoryFacetFilters[key].push(`meta.custom.type:${searchValue}`);
        break;
      case 'area':
        categoryFacetFilters[key].push(`meta.custom.area:${searchValue}`);
        break;
      case 'climate':
        categoryFacetFilters[key].push(`meta.custom.climate:${searchValue}`);
        break;
      case 'english_name':
        categoryFacetFilters[key].push(`meta.custom.english_name:${searchValue}`);
        break;
      case 'excerpt':
        categoryFacetFilters[key].push(`meta.custom.excerpt:${searchValue}`);
        break;
      case 'main_variety':
        categoryFacetFilters[key].push(`meta.custom.main_variety:${searchValue}`);
        break;
      case 'country':
        categoryFacetFilters[key].push(...normalizeMetaobjectFormatArray(`meta.custom.country:${searchValue}`));
        break;
      case 'manufacturer':
        categoryFacetFilters[key].push(`meta.custom.manufacturer:${searchValue}`);
        break;
      case 'scent':
        categoryFacetFilters[key].push(...normalizeMetaobjectFormatArray(`meta.custom.scent:${searchValue}`));
        break;
      case 'slimilarproduct':
        categoryFacetFilters[key].push(`meta.custom.slimilarproduct:${searchValue}`);
        break;
      case 'soil':
        categoryFacetFilters[key].push(`meta.custom.soil:${searchValue}`);
        break;
      case 'taste':
        categoryFacetFilters[key].push(`meta.custom.taste:${searchValue}`);
        break;
      case 'temperature':
        categoryFacetFilters[key].push(`meta.custom.temperature:${searchValue}`);
        break;
      case 'variety':
        categoryFacetFilters[key].push(`meta.custom.variety:${searchValue}`);
        break;
      case 'year':
        categoryFacetFilters[key].push(`meta.custom.year:${searchValue}`);
        break;
      case 'cork':
        categoryFacetFilters[key].push(`meta.spec.cork:${searchValue}`);
        break;
      case 'volume':
        categoryFacetFilters[key].push(`meta.spec.volume:${searchValue}`);
        break;
      case 'acrid':
        categoryFacetFilters[key].push(`meta.tastenotes.acrid:${searchValue}`);
        break;
      case 'body':
        categoryFacetFilters[key].push(`meta.tastenotes.body:${searchValue}`);
        break;
      case 'impression':
        categoryFacetFilters[key].push(`meta.tastenotes.impression:${searchValue}`);
        break;
      case 'sour':
        categoryFacetFilters[key].push(`meta.tastenotes.sour:${searchValue}`);
        break;
      case 'sweet':
        categoryFacetFilters[key].push(`meta.tastenotes.sweet:${searchValue}`);
        break;
      case 'price':
        priceFilter.push(searchValue);
        break;
      case 'collections':
        categoryFacetFilters[key].push(`collections:${searchValue}`);
        break;
      default:
        break;
    }
  });

  // type area等のカテゴリ内はOR検索、カテゴリ間はAND検索
  const facetFilters = [];
  for (const category in categoryFacetFilters) {
    const categoryFilter = categoryFacetFilters[category];
    facetFilters.push(categoryFilter);
  }

  const filters = priceFilter.join(' OR ')

  const configureParameters = {
    query: params.get('q') || '',
    hitsPerPage: 10,
    filters: filters,
    facetFilters: facetFilters,
  };

  console.log(facetFilters.toString());

  const configure = instantsearch.widgets.configure(configureParameters);

  const hits = instantsearch.widgets.hits({
    container: '#hits',
    templates: {
      empty(results, { html }) {
      return html`
        <div class="p-searchEmpty">
          <p class="p-searchEmpty__text">「${results.query}」に一致する商品が見つかりませんでした。</p>
          <div class="p-searchEmpty__links">
            <a href="/collections/all" class="a-button -key">すべての商品を見る</a>
          </div>
        </div>
      `;
    },
    // お気に入り機能コメントアウト中
    //   <div class="m-itemCard__fav">
    //   <button class='a-fav' data-product-id=${hit.id} data-product-name=${hit.title} data-object-id=${hit.objectID}>
    //     <svg width="26" height="24" viewBox="0 0 26 24" xmlns="http://www.w3.org/2000/svg">
    //       <path d="M7.81517 1C3.73726 1 1 4.422 1 8.648C1 13.444 7.46216 19.174 12.9984 23C18.5366 19.174 24.9235 13.352 24.9987 8.648C25.0662 4.422 22.4274 1 18.3495 1C16.6095 1 14.8445 1.954 12.9984 3.866C11.1523 1.954 9.55513 1 7.81517 1Z" stroke-linejoin="round"/>
    //     </svg>
    //   </button>
    // </div>
      item(hit, { html, components }) {
  // 画像URLの安全な取得
  let imageUrl = '';
  if (hit.image) {
    const sized = getSizedImageUrl(hit.image, 'medium');
    // getSizedImageUrlがnullを返した場合は元の画像URLを使用
    imageUrl = sized || hit.image;
  } else if (hit.featured_image) {
    // featured_imageフィールドも確認
    const sized = getSizedImageUrl(hit.featured_image, 'medium');
    imageUrl = sized || hit.featured_image;
  }
  
  return html`
    <div class="m-itemCard  -sideImg">
      <a href="/products/${hit.handle}" class="m-itemCard__link"></a>  

      <div class="m-itemCard__img">
        <div class="m-itemCard__imgInner">
          ${imageUrl
            ? html`<img 
                src="${imageUrl}" 
                loading="lazy"
                onerror="this.style.display='none';"
              />` 
            : ''}
        </div>
      </div>
      <div class="m-itemCard__content">
        ${hit.meta?.custom?.type
          ? html`<div class="m-itemCard__tag">${html([generateWineTag(hit.meta.custom.type)])}</div>`
          : ''}
        <div class="m-itemCard__title">${hit.title}</div>
        <div class="m-itemCard__area">
          <span class="m-itemCard__areaFlag">
            ${hit.meta?.custom?.country?.value?.flag_image?.value
              ? html`<img
                  src="${getSizedImageUrl(hit.meta.custom.country.value.flag_image.value, 'medium') || hit.meta.custom.country.value.flag_image.value}"
                  loading="lazy"
                />`
              : ''}
          </span>
          <span class="m-itemCard__areaTitle">
            ${hit.meta?.custom?.country?.value?.name ? html`${hit.meta.custom.country.value.name}` : ''}
          </span>
        </div>
        <div class="m-itemCard__detail">
          ${hit.meta?.custom?.excerpt ? html`${hit.meta.custom.excerpt}` : ''}
        </div>
        <div class="m-itemCard__lower">
          
          <div class="m-itemCard__price">
            ${hit.meta?.custom?.member_discount_percent
              ? html`
                  <div class="m-itemCard__priceOriginal">
                    ¥${hit.price}
                    <span class="m-itemCard__priceTax"> (税込) </span>
                  </div>
                  <div class="m-itemCard__priceMember">
                    ¥${Math.floor(hit.price - (hit.price * hit.meta.custom.member_discount_percent))}
                    <span class="m-itemCard__priceTax"> (税込) </span>
                    <img
                      src="https://cdn.shopify.com/s/files/1/0740/5115/8311/files/40_OFF2.webp?v=1785478833"
                      alt="会員クーポン"
                      class="m-itemCard__memberPriceLabel"
                      loading="lazy"
                    />
                  </div>
                `
              : html`
                  ¥${hit.price}
                  <span class="m-itemCard__priceTax"> (税込) </span>
                `}
          </div>

          <div class="m-itemCard__cart">
            ${(hit.inventory_quantity ?? 0) > 0
              ? html`<button
                  class="a-button -addCart"
                  type=""
                  data-micromodal-trigger="modal-cart"
                  data-product-max-quantity="${hit.inventory_quantity}"
                  data-product-variant-id="${hit.objectID}"
                >
                  <span class="a-button__label">カートに入れる</span>
                </button>`
              : html`<button class="a-button -addCart -disabled" disabled>
                  <span class="a-button__label">在庫がありません</span>
                </button>`}
          </div>
        </div>
      </div>
    </div>
  `;
},
    },
    cssClasses: {
      root: 'p-itemList__itemList',
      list: ['o-itemList  -vertical', 'o-itemList__item'],
    },
  });

  // Create the render function
  const renderPagination = (renderOptions, isFirstRender) => {
    const { pages, currentRefinement, nbPages, isFirstPage, isLastPage, refine, createURL } = renderOptions;

    const container = document.querySelector('#pagination');
    const prevUrl = new URL(window.location.href);
    prevUrl.searchParams.set('page', currentRefinement);

    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('page', currentRefinement + 2);

    const url = new URL(window.location.href);
    const params = url.searchParams;
    const pageParam = params.get('page');
    const page = pageParam ? pageParam - 1 : 0;

    if (page != currentRefinement) refine(page);

    container.innerHTML = `
    <div class="p-itemList__itemListPagination">
      <div class="m-pagination">
        ${
          !isFirstPage
            ? `<a href="${prevUrl}" class="m-pagination__button -prev"></a>`
            : '<span class="m-pagination__button -prev"></span>'
        }
        <span class="m-pagination__page">
          <span class="-current">${currentRefinement + 1}</span>
          <span>of</span>
          <span>${nbPages}</span>
        </span>
        ${
          !isLastPage
            ? `<a href="${nextUrl}" class="m-pagination__button -next"></a>`
            : '<span class="m-pagination__button -next"></span>'
        }
      </div>
    </div>
  `;
  };

  // Create the custom widget
  const customPagination = instantsearch.connectors.connectPagination(renderPagination);

  const stats = instantsearch.widgets.stats({
    container: '#stats',
    templates: {
      text(data, { html }) {
        return html`
          <div class="p-itemList__amount">
            ${data.nbHits} items
            <div class="p-itemList__title">
              <span>${searchTitle || (data.query ? `${data.query}の検索結果` : '全商品')}</span>
            </div>
          </div>
        `;
      },
    },
  });

  search.addWidgets([
    configure,
    hits,
    customPagination({
      container: document.querySelector('#pagination'),
    }),
    stats,
  ]);

  search.on('render', () => {
    onDOMContentLoaded();
    addFavEvent();
  });

  search.start();
});


const addFavEvent = () => {
  const aFavs = document.querySelectorAll('.a-fav');
  const customerId = document.querySelector('#customer-id-container').dataset.customerId;
  // ログインしていなかったらお気に入りボタンを非表示にする
  if (!customerId){
    aFavs.forEach(button => {
      button.hidden = true;
    });
    return;
  }

  const getFormData = {
    customerId: customerId
  };
  // お気に入りを反映させる
  fetch(`https://9sigixtch6.execute-api.ap-northeast-1.amazonaws.com/production/bookmarks/products?customerId=${customerId}`, {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json'
    },
  })
  .then(response => response.json())
  .then(data => {
      data.forEach(product => {
        const productId = product['id'];
        const aFav = document.querySelector(`.a-fav[data-product-id="${productId}"]`);
        if (!aFav) return;
        aFav.classList.add('-favorited');
      });
  })
  .catch((error) => {
      console.error('Error:', error);
  });

  const debounce = (func, wait)=> {
    let timeout;
    return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
  }
  const debounceFetch = debounce((sendUrl, sendMethod, formData) => {
    fetch(sendUrl, {
        method: sendMethod,
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
        console.log('Success:', data);
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  }, 500);
  
  aFavs.forEach(button => {
    // ログインしていなかったらお気に入りボタンを非表示にする
    if (!customerId){
      button.hidden = false;
    }
    button.addEventListener('click', function(event) {
      event.preventDefault(); 
      // .a-fav にfavorite がついていたら削除、ついていなかったら追加
      const isFavorite = button.classList.contains('-favorited') ;
      if (isFavorite) {
        button.classList.remove('-favorited');
      } else {
        button.classList.add('-favorited');
      }
      const productId = button.dataset.productId;
      const objectId= button.dataset.objectId;
      const productName= button.dataset.productName;
      let formData = {
          customerId: customerId,
          productId : productId
      };
      if (!isFavorite) {
        formData['objectId'] = objectId;
        formData['productName'] = productName;
      }

      const sendUrl = isFavorite ? 'https://9sigixtch6.execute-api.ap-northeast-1.amazonaws.com/production/bookmarks/delete'
      : 'https://9sigixtch6.execute-api.ap-northeast-1.amazonaws.com/production/bookmarks';
      const sendMethod = isFavorite ? 'DELETE' : 'POST';


      
      debounceFetch(sendUrl, sendMethod, formData);
    });
  });
}

// 絞り込みボタン押したらメニュー出るようにする
document.addEventListener('DOMContentLoaded', function () {
  const searchModalButtons = document.querySelectorAll('.-searchModalButton');
  searchModalButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      document.getElementById('modal-search').classList.toggle('is-open');
    });
  });
});

// スマホの絞り込みメニューで矢印を押したらリストが開くようにする
document.addEventListener('DOMContentLoaded', function () {
  const jsModalSearchBoxTriggers = document.querySelectorAll('.js-modalSearch-box-trigger');
  jsModalSearchBoxTriggers.forEach((jsModalSearchBoxTrigger) => {
    jsModalSearchBoxTrigger.addEventListener('click', function (t) {
      jsModalSearchBoxTrigger.classList.toggle('is-open');
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const url = new URL(window.location.href);
  const params = url.searchParams;

  const tagList = document.querySelector('.p-itemList__tagList');
  const tagItems = [];
  params.forEach((value, key) => {
    const searchValue = getSearchValue(key, value, true);
    if (searchValue !== '不明な値') {
      tagItems.push(searchValue);
    }
  });

  tagItems.forEach((tagItem) => {
    const tag = document.createElement('div');
    tag.classList.add('p-itemList__tagItem');
    tag.innerHTML = `
      <span class="a-tag  -withXbutton">
        <span class="a-tag__label">${tagItem}</span>
        <button class="a-tag__closeButton"></button>
      </span>
    `;
    tagList.appendChild(tag);
  });
  // tag__closeButton押したらタグ消えるようにする、URLのパラメータも消す
  const tagCloseButtons = document.querySelectorAll('.a-tag__closeButton');
  tagCloseButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const tag = button.closest('.p-itemList__tagItem');
      tag.remove();
      const tagLabel = tag.querySelector('.a-tag__label').textContent;
      const url = new URL(window.location.href);
      const params = url.searchParams;
      params.set('page', 1);

      params.forEach((value, key) => {
        const searchValue = getSearchValue(key, value, true);
        if (searchValue === tagLabel) {
          params.delete(key, value);
        }
      });
      // 画面遷移
      window.location.href = url;
    });
  });
});

// ワインタグ生成
function generateWineTag(wineClass) {
  let cssClass;
  switch (wineClass) {
    case '赤ワイン':
      cssClass = 'cat01';
      break;
    case '白ワイン':
      cssClass = 'cat02';
      break;
    case 'ロゼワイン':
      cssClass = 'cat03';
      break;
    case 'オレンジワイン':
      cssClass = 'cat04';
      break;
    case 'スパークリングワイン':
    case 'スパークリング':
      cssClass = 'cat05';
      break;
    case '脱アルコールワイン・ワインジュース':
    case 'ノンアル / 脱アルワイン':
      cssClass = 'cat06';
      break;
    case 'ビール・脱アルコールビール':
    case 'ビール / 脱アルビール':
      cssClass = 'cat07';
      break;
    default:
      cssClass = 'cat-etc';
  }

  let label;
  switch (wineClass) {
    case 'スパークリングワイン':
      label = 'スパークリング';
      break;
    case '脱アルコールワイン・ワインジュース':
      label = 'ノンアル / 脱アルワイン';
      break;
    case 'ビール・脱アルコールビール':
      label = 'ビール / 脱アルビール';
      break;
    default:
      label = wineClass;
  }

  return `<span class="a-itemTag -${cssClass}"><span class="a-itemTag__label">${label}</span></span>`;
}

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * https://github.com/Shopify/slate.git.
 *
 */

/**
 * Preloads an image in memory and uses the browsers cache to store it until needed.
 *
 * @param {Array} images - A list of image urls
 * @param {String} size - A shopify image size attribute
 */

function preload(images, size) {
  if (typeof images === 'string') {
    images = [images];
  }

  for (let i = 0; i < images.length; i++) {
    const image = images[i];
    loadImage(getSizedImageUrl(image, size));
  }
}

/**
 * Loads and caches an image in the browsers cache.
 * @param {string} path - An image url
 */
function loadImage(path) {
  new Image().src = path;
}

/**
 * Find the Shopify image attribute size
 *
 * @param {string} src
 * @returns {null}
 */
function imageSize(src) {
  const match = src.match(
    /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
  );

  if (match) {
    return match[1];
  } else {
    return null;
  }
}

/**
 * Adds a Shopify size attribute to a URL
 *
 * @param src
 * @param size
 * @returns {*}
 */
function getSizedImageUrl(src, size) {
  // デバッグ用
  console.log('=== getSizedImageUrl called ===');
  console.log('Input src:', src);
  console.log('Input size:', size);
  
  if (!src) {
    console.log('Result: src is null/undefined');
    return null;
  }

  if (size === null) {
    console.log('Result: size is null, returning original src');
    return src;
  }

  if (size === 'master') {
    console.log('Result: size is master');
    return removeProtocol(src);
  }

  const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
  console.log('Match result:', match);

  if (match) {
    const prefix = src.split(match[0]);
    const suffix = match[0];
    const result = removeProtocol(`${prefix[0]}_${size}${suffix}`);
    console.log('Result:', result);
    return result;
  } else {
    console.log('Result: No match found, returning null');
    return null;
  }
}

function removeProtocol(path) {
  return path.replace(/http(s)?:/, '');
}
/**
 * Image Helper Functions End
 */


/**
 * 検索絞り込み用の値を取得する関数まとめ
 */
function getSearchValue(key,value,useDisplay = false) {
  const nameMap = {
        'collections': {
      'gifts': { 'display': 'プレゼントにおすすめ', 'search': 'gifts' },
      'daily-use': { 'display': 'デイリーワインに おすすめ', 'search': 'daily-use' },
      'spainwinewes': { 'display': 'スペインワインフェス', 'search': 'spainwinewes' },
      'クリアランスセールベルビーニョ': { 'display': 'クリアランスセールベルビーニョ', 'search': 'クリアランスセールベルビーニョ' },
      'New-Arrival': { 'display': '新商品', 'search': 'New-Arrival' },
      '特選ワイン': { 'display': '特選ワイン', 'search': '特選ワイン' },
      'pagos-altos-de-acered-wine': { 'display': 'パゴス・アルトス・デ・アセレー', 'search': 'pagos-altos-de-acered-wine' },
    },
    'type' :{
      'red-wine': { 'display': '赤ワイン', 'search': '' },
      'white-wine': { 'display': '白ワイン', 'search': '' },
      'rose-wine': { 'display': 'ロゼワイン', 'search': '' },
      'orange-wine': { 'display': 'オレンジワイン', 'search': '' },
      'sparkling-wine': { 'display': 'スパークリングワイン', 'search': '' },
      'dealcoholized-wine-juice': { 'display': '脱アルコールワイン・ワインジュース', 'search': '' },
      'beer': { 'display': 'ビール・脱アルコールビール', 'search': '' },
      'sherry-wine': { 'display': 'シェリー酒', 'search': 'シェリー酒' },
    },
    'scent': {
      'lemon-orange': { 'display': 'レモン・オレンジなど', 'search': 'gid://shopify/Metaobject/16070017319' },
      'apple-pear': { 'display': 'リンゴ・洋ナシなど', 'search': 'gid://shopify/Metaobject/21910782247' },
      'peach-apricot': { 'display': 'モモ・アプリコットなど', 'search': 'gid://shopify/Metaobject/21913338151' },
      'pineapple-passionfruit': { 'display': 'パイナップル・パッションフルーツなど', 'search': 'gid://shopify/Metaobject/21910815015' },
      'strawberry-cherry-cassis': { 'display': 'イチゴ・チェリー・カシスなど', 'search': 'gid://shopify/Metaobject/16070050087' },
      'blackberry-blueberry': { 'display': 'ブラックベリー・ブルーベリーなど', 'search': 'gid://shopify/Metaobject/21913370919' },
      'vanilla-licorice': { 'display': 'バニラ・リコリスなど', 'search': 'gid://shopify/Metaobject/21913239847' },
      'coconut-hazelnut': { 'display': 'ココナッツ・ヘーゼルナッツなど', 'search': 'gid://shopify/Metaobject/21910847783' },
      'chocolate-coffee-caramel': { 'display': 'チョコレート・コーヒー・キャラメルなど', 'search': 'gid://shopify/Metaobject/21913272615' },
    },
    'sweet': {
      'weak': { 'display': '甘味: 弱い', 'search': '弱い' },
      'somewhat-weak': { 'display': '甘味: やや弱い', 'search': 'やや弱い' },
      'moderate': { 'display': '甘味: 中程度', 'search': '中程度' },
      'somewhat-strong': { 'display': '甘味: やや強い', 'search': 'やや強い' },
      'strong': { 'display': '甘味: 強い', 'search': '強い' },
    },
    'sour': {
      'weak': { 'display': '酸味: 弱い', 'search': '弱い' },
      'somewhat-weak': { 'display': '酸味: やや弱い', 'search': 'やや弱い' },
      'moderate': { 'display': '酸味: 中程度', 'search': '中程度' },
      'somewhat-strong': { 'display': '酸味: やや強い', 'search': 'やや強い' },
      'strong': { 'display': '酸味: 強い', 'search': '強い' },
    },
    'acrid': {
      'weak': { 'display': '渋味: 弱い', 'search': '弱い' },
      'somewhat-weak': { 'display': '渋味: やや弱い', 'search': 'やや弱い' },
      'moderate': { 'display': '渋味: 中程度', 'search': '中程度' },
      'somewhat-strong': { 'display': '渋味: やや強い', 'search': 'やや強い' },
      'strong': { 'display': '渋味: 強い', 'search': '強い' },
    },
    'impression': {
      'refreshing': { 'display': '印象: すっきり', 'search': 'すっきり' },
      'moderate': { 'display': '印象: 中程度', 'search': '中程度' },
      'mellow': { 'display': '印象: まったり', 'search': 'まったり' },
    },
    'body': {
      'light': { 'display': 'ボディ: ライト', 'search': 'ライトボディ' },
      'medium': { 'display': 'ボディ: ミディアム', 'search': 'ミディアムボディ' },
      'full': { 'display': 'ボディ: フル', 'search': 'フルボディ' },
    },
    'price': {
      '0-999': { 'display': '~¥999', 'search': 'price <= 999' },
      '1000-1999': { 'display': '¥1,000〜¥1,999', 'search': 'price:1000 TO 1999' },
      '2000-2999': { 'display': '¥2,000〜¥2,999', 'search': 'price:2000 TO 2999' },
      '3000-4999': { 'display': '¥3,000〜¥4,999', 'search': 'price:3000 TO 4999' },
      '5000-9999': { 'display': '¥5,000〜¥9,999', 'search': 'price:5000 TO 9999' },
      'over10000': { 'display': '¥10,000〜', 'search': 'price >= 10000' },
    },
    'main_variety':{
      'airen': { 'display': 'アイレン（白）', 'search': '' },
      'albarino': { 'display': 'アルバリーニョ（白）', 'search': '' },
      'ondarrabi-zuri': { 'display': 'オンダラビ・スリ（白）', 'search': '' },
      'garnacha-blanca': { 'display': 'ガルナッチャ・ブラン（白）', 'search': '' },
      'godello': { 'display': 'ゴデージョ（白）', 'search': '' },
      'chardonnay': { 'display': 'シャルドネ (白)', 'search': '' },
      'sauvignon-blanc': { 'display': 'ソーヴィニョン・ブラン (白)', 'search': '' },
      'treixadura': { 'display': 'トレイシャドゥーラ（白）', 'search': '' },
      'trebbiano': { 'display': 'トレッビアーノ（白）', 'search': '' },
      'verdejo': { 'display': 'ベルデホ (白)', 'search': '' },
      'macabeo-viura': { 'display': 'マカベオ/ヴィウラ (白)', 'search': '' },
      'riesling': { 'display': 'リースリング（白）', 'search': '' },
      'cabernet-sauvignon': { 'display': 'カベルネ・ソーヴィニョン（赤）', 'search': '' },
      'garnacha': { 'display': 'ガルナッチャ（赤）', 'search': '' },
      'garnacha-tintorera': { 'display': 'ガルナッチャ・ティントレラ（赤）', 'search': '' },
      'garnacha-fina': { 'display': 'ガルナッチャ・フィナ（赤）', 'search': '' },
      'garnacha-peluda': { 'display': 'ガルナッチャ・ペルーダ（赤）', 'search': '' },
      'carinena': { 'display': 'カリニェナ（赤）', 'search': '' },
      'sangiovese': { 'display': 'サンジョベーゼ（赤）', 'search': '' },
      'syrah': { 'display': 'シラー（赤）', 'search': '' },
      'tempranillo': { 'display': 'テンプラニージョ（赤）', 'search': '' },
      'dornfelder': { 'display': 'ドルンフェルダー（赤）', 'search': '' },
      'merlot': { 'display': 'メルロー（赤）', 'search': '' },
      'mencia': { 'display': 'メンシーア（赤）', 'search': '' },
      'monastrell': { 'display': 'モナストレル（赤）', 'search': '' },
    },
    'country': {
      'spain': { 'display': 'スペイン', 'search': 'gid://shopify/Metaobject/21910094119' },
      'south-africa': { 'display': '南アフリカ', 'search': 'gid://shopify/Metaobject/23366664487' },
    },
    'year': {
      '2023': { 'display': '2023年', 'search': '2023' },
      '2022': { 'display': '2022年', 'search': '2022' },
      '2021': { 'display': '2021年', 'search': '2021' },
      '2020': { 'display': '2020年', 'search': '2020' },
      '2019': { 'display': '2019年', 'search': '2019' },
      '2018': { 'display': '2018年', 'search': '2018' },
      '2017': { 'display': '2017年', 'search': '2017' },
      '2016': { 'display': '2016年', 'search': '2016' },
      '2015': { 'display': '2015年', 'search': '2015' },
      '2014': { 'display': '2014年', 'search': '2014' },
      '2013': { 'display': '2013年', 'search': '2013' },
      '2012': { 'display': '2012年', 'search': '2012' },
      '2011': { 'display': '2011年', 'search': '2011' },
      '2010': { 'display': '2010年', 'search': '2010' },
      '2009': { 'display': '2009年', 'search': '2009' },
      '2008': { 'display': '2008年', 'search': '2008' },
      '2007': { 'display': '2007年', 'search': '2007' },
      '2006': { 'display': '2006年', 'search': '2006' },
      '2005': { 'display': '2005年', 'search': '2005' },
      '2004': { 'display': '2004年', 'search': '2004' },
      '2003': { 'display': '2003年', 'search': '2003' },
      '2002': { 'display': '2002年', 'search': '2002' },
      '2001': { 'display': '2001年', 'search': '2001' },
      '2000': { 'display': '2000年', 'search': '2000' },
      '1999': { 'display': '1999年', 'search': '1999' },
      '1998': { 'display': '1998年', 'search': '1998' },
      '1997': { 'display': '1997年', 'search': '1997' },
      '1996': { 'display': '1996年', 'search': '1996' },
      '1995': { 'display': '1995年', 'search': '1995' },
      '1994': { 'display': '1994年', 'search': '1994' },
      '1993': { 'display': '1993年', 'search': '1993' },
      '1992': { 'display': '1992年', 'search': '1992' },
      '1991': { 'display': '1991年', 'search': '1991' },
      '1990': { 'display': '1990年', 'search': '1990' },
      '1989': { 'display': '1989年', 'search': '1989' },
      '1988': { 'display': '1988年', 'search': '1988' },
      '1987': { 'display': '1987年', 'search': '1987' },
      '1986': { 'display': '1986年', 'search': '1986' },
      '1985': { 'display': '1985年', 'search': '1985' },
      '1984': { 'display': '1984年', 'search': '1984' },
      '1983': { 'display': '1983年', 'search': '1983' },
      '1982': { 'display': '1982年', 'search': '1982' },
      '1981': { 'display': '1981年', 'search': '1981' },
      '1980': { 'display': '1980年', 'search': '1980' },
      '1979': { 'display': '1979年', 'search': '1979' },
      '1978': { 'display': '1978年', 'search': '1978' },
      '1977': { 'display': '1977年', 'search': '1977' },
      '1976': { 'display': '1976年', 'search': '1976' },
      '1975': { 'display': '1975年', 'search': '1975' },
      '1974': { 'display': '1974年', 'search': '1974' },
      '1973': { 'display': '1973年', 'search': '1973' },
      '1972': { 'display': '1972年', 'search': '1972' },
      '1971': { 'display': '1971年', 'search': '1971' },
      '1970': { 'display': '1970年', 'search': '1970' },
      '1969': { 'display': '1969年', 'search': '1969' },
      '1968': { 'display': '1968年', 'search': '1968' },
      '1967': { 'display': '1967年', 'search': '1967' },
      '1966': { 'display': '1966年', 'search': '1966' },
      '1965': { 'display': '1965年', 'search': '1965' },
      '1964': { 'display': '1964年', 'search': '1964' },
      '1963': { 'display': '1963年', 'search': '1963' },
      '1962': { 'display': '1962年', 'search': '1962' },
      '1961': { 'display': '1961年', 'search': '1961' },
      '1960': { 'display': '1960年', 'search': '1960' },
      '1959': { 'display': '1959年', 'search': '1959' },
      '1958': { 'display': '1958年', 'search': '1958' },
      '1957': { 'display': '1957年', 'search': '1957' },
      '1956': { 'display': '1956年', 'search': '1956' },
      '1955': { 'display': '1955年', 'search': '1955' },
      '1954': { 'display': '1954年', 'search': '1954' },
      '1953': { 'display': '1953年', 'search': '1953' },
      '1952': { 'display': '1952年', 'search': '1952' },
      '1951': { 'display': '1951年', 'search': '1951' },
      '1950': { 'display': '1950年', 'search': '1950' },
    },
    'climate': {
      'continental': { 'display': '大陸性気候', 'search': '' },
      'mediterranean': { 'display': '地中海性気候', 'search': '' },
      'maritime': { 'display': '海洋性気候', 'search': '' },
    },
    'temperature': {
      'cool': { 'display': '冷涼', 'search': '' },
      'moderate': { 'display': '温和', 'search': '' },
      'warm': { 'display': '温暖', 'search': '' },
      'hot': { 'display': '高温', 'search': '' },
    },
    'soil': {
      'sandy': { 'display': '砂質', 'search': '' },
      'clay': { 'display': '粘土質', 'search': '' },
      'limestone': { 'display': '石灰質', 'search': '' },
    },
    'manufacturer':{
      'finca-ajende': { 'display': 'フィンカ・アジェンデ', 'search': '' },
      'pago-los-balancines': { 'display': 'パゴ ロス バランシーネス', 'search': '' },
      'bodegas-altos-de-trona': { 'display': 'ボデガス アルトス・デ・トローナ', 'search': '' },
      'a-te-rocca': { 'display': 'ア・テ ロッカ', 'search': '' },
      'editaria': { 'display': 'エデタリア', 'search': '' },
      'domaine-lupier': { 'display': 'ドメーヌ ルピエール', 'search': '' },
      'raul-perez': { 'display': 'ラウル ペレス', 'search': '' },
      'panavac': { 'display': 'パナバック', 'search': '' },
      'gainza': { 'display': 'ガインツァ', 'search': '' },
      'bodegas-alcardet': { 'display': 'ボデガス アルカルデット', 'search': '' },
      'vicente-gandia': { 'display': 'ヴィセンテ ガンディア', 'search': '' },
      'j-garcia-carrion': { 'display': 'J.ガルシア カリオン', 'search': '' },
      'sijar-de-siros': { 'display': 'シジャール デ シロス', 'search': '' },
      'bodegas-mansanos': { 'display': 'ボデガス・マンサーノス', 'search': '' },
      'javier-sanz': { 'display': 'ハヴィエル サンス', 'search': '' },
      'celler-pasanau': { 'display': 'セラー パサナウ', 'search': '' },
      'figjaboa': { 'display': 'フィジャボア', 'search': '' },
      'bodegas-valduero': { 'display': 'ボデガス・ヴァルドゥエロ', 'search': '' },
    },
  };

  if (nameMap[key] && nameMap[key][value]) {
    if (useDisplay) {
      return nameMap[key][value]['display'];
    }
    return nameMap[key][value]['search'] || nameMap[key][value]['display']
  }
  return '不明な値';
}

function normalizeMetaobjectFormatArray(query) {
  const colonIndex = query.indexOf(':');
  const key = query.substring(0, colonIndex);
  const searchValue = query.substring(colonIndex + 1);

  return [`${key}:["${searchValue}` , `${key}:${searchValue}` , `${key}:${searchValue}"]`];
}
/**
 * 検索絞り込み用の値を取得する関数まとめ End
 */